// extracted by mini-css-extract-plugin
export default {"alert":"alert§omMnOS2dB9enS62wUXUp"};